import "./index.css"
// Removes ugly focus ring unless keyboard navigation detected
import "focus-visible/dist/focus-visible"
import { AlertDialogProvider, Toaster, Tooltip } from "@overmap-ai/blocks"
import { ImageCapturerProvider, ImageViewerProvider, ScannerProvider, VideoViewerProvider } from "@overmap-ai/forms"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import wasmUrl from "zxing-wasm/reader/zxing_reader.wasm?url"

import { App } from "./App"
import { AlertDialogBridge } from "./components/AlertDialogBridge/AlertDialogBridge"
import { AppUpdater } from "./components/AppUpdater/AppUpdater"
import { ConditionalStrictMode } from "./components/ConditionalStrictMode/ConditionalStrictMode"
import { PostHog } from "./components/PostHog/PostHog"
import { SelectedAssetProvider } from "./contexts/SelectedAssetsContext/provider"
import { TextConfirmationDialogProvider } from "./contexts/TextConfirmationDialogContext/provider"
import { ThemeProvider } from "./contexts/ThemeContext"
import { ViewportSizeProvider } from "./contexts/ViewportSizeContext/provider"
import { appStore, persistor } from "./store"
import { SpinnerView } from "./views/SpinnerView/SpinnerView"

const container = document.getElementById("root") as HTMLElement
const root = createRoot(container)

root.render(
	<ConditionalStrictMode condition={import.meta.env.REACT_APP_DISABLE_STRICT_MODE !== "1"}>
		<Provider store={appStore}>
			<PersistGate loading={<SpinnerView />} persistor={persistor}>
				<ViewportSizeProvider>
					<ThemeProvider>
						<Tooltip.Provider>
							<Toaster position="bottom-right" className="z-[100000]" />
							<AlertDialogProvider>
								<AlertDialogBridge />
								<TextConfirmationDialogProvider>
									<ImageCapturerProvider>
										<ImageViewerProvider>
											<VideoViewerProvider>
												<ScannerProvider wasmUrl={wasmUrl}>
													<AppUpdater />
													<SelectedAssetProvider>
														<PostHog>
															<App />
														</PostHog>
													</SelectedAssetProvider>
												</ScannerProvider>
											</VideoViewerProvider>
										</ImageViewerProvider>
									</ImageCapturerProvider>
								</TextConfirmationDialogProvider>
							</AlertDialogProvider>
						</Tooltip.Provider>
					</ThemeProvider>
				</ViewportSizeProvider>
			</PersistGate>
		</Provider>
	</ConditionalStrictMode>,
)
